import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { images } from '../data/site';

const points = [
  'A welcoming environment for children and families.',
  "An approach that respects every child's individuality.",
  'Open communication with parents and caregivers.'
];
export default function Parents() {
  return (
    <section className="section parents">
      <div className="container parents-grid">
        <img className="parents-photo" src={images.parents} alt="Parent sharing a caring moment with their child" loading="lazy" width="720" height="480" />
        <div className="parents-copy"><span className="eyebrow">FOR PARENTS</span><h2>Because Every Child Deserves to Feel Understood.</h2>
          <p>Choosing the right environment for your child is an important decision. We want families to feel welcome, ask questions, and learn more about how Minrose may support their child's individual journey.</p>
          <div className="parent-points">{points.map((point) => <div key={point}><SafeIcon icon={FiIcons.FiCheckCircle} aria-hidden="true" /><span>{point}</span></div>)}</div>
          <a className="button button-dark" href="#contact">Let's Talk About Your Child <span aria-hidden="true">→</span></a>
        </div>
        <SafeIcon icon={FiIcons.FiSun} className="parents-sun" aria-hidden="true" />
      </div>
    </section>
  );
}